import React, { useEffect } from "react"
import { Link } from "gatsby"
import { Helmet } from "react-helmet"

import Layout from "../components/layout"
import SEO from "../components/seo"
import "../scss/main.scss"
import Hero from "../components/Hero"
import About from "../components/About"
import Offers from "../components/Offers"
import Blog from "../components/Blog"
import Contact from "../components/Contact"

const IndexPage = ({ data }) => {

  return (
    <>
      <SEO title="Strona główna" />
        <Hero />
        <About />
        <Offers />
        {/*<Blog />*/}
        <Contact />
    </>
  )
}

export default IndexPage
